var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-cmi"},[_c('a',{staticClass:"back-a",attrs:{"href":_vm.cmiUrl}},[_c('img',{attrs:{"src":require("./img/back_cmi.png")}}),_c('span',[_vm._v("返回CMI平台")])])])}
var staticRenderFns = []

export { render, staticRenderFns }